/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_DeprovisionInputs */



/**
* | output |
* | --- |
* | "Deleted the server from Colossus" |
*
* @param {Activity_DeprovisionInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_deprovision = /** @type {((inputs?: Activity_DeprovisionInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_DeprovisionInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер удалён из Colossus")
	return /** @type {LocalizedString} */ ("Deleted the server from Colossus")
});